module.exports = __webpack_public_path__ + "img/M951.fffaa257.jpg";